import type {
  ProductOfferCtaCard,
  ProductOfferCtaCardsGroup
} from '@percent/cause-dashboard/storyblok/types/storyblok-components'
import { ProductOfferCTACard } from '../productOfferCTACard/ProductOfferCTACard'
import styles from './ProductOfferCTACardsGroup.module.scss'

function isProductOfferCtaCardsGroup(blok: unknown): blok is ProductOfferCtaCardsGroup {
  return Boolean(
    blok && typeof blok === 'object' && (blok as { component?: string }).component === 'product_offer_cta_cards_group'
  )
}

function isProductOfferCtaCard(blok: unknown): blok is ProductOfferCtaCard {
  return Boolean(
    blok && typeof blok === 'object' && (blok as { component?: string }).component === 'product_offer_cta_card'
  )
}

export type StoryblokProductOfferCtaCardsGroupProps = {
  body: unknown[]
  keyPrefix: string
}

export function ProductOfferCTACardsGroup({ body, keyPrefix }: Readonly<StoryblokProductOfferCtaCardsGroupProps>) {
  const groups = body.filter(isProductOfferCtaCardsGroup)
  if (!groups.length) {
    return null
  }

  return (
    <>
      {groups.map((group, gi) => {
        const cards = (group.cards ?? []).filter(isProductOfferCtaCard)
        if (!cards.length) {
          return null
        }
        const rowContent = cards.map((card, ci) => (
          <ProductOfferCTACard key={card._uid ?? `${keyPrefix}-c${ci}`} card={card} />
        ))
        return group.full_width ? (
          <div
            key={`${keyPrefix}-g${gi}`}
            className={styles.fullBleedWrapper}
            data-testid="product-offer-cta-cards-full-bleed"
          >
            <div className={styles.row}>{rowContent}</div>
          </div>
        ) : (
          <div key={`${keyPrefix}-g${gi}`} className={styles.row}>
            {rowContent}
          </div>
        )
      })}
    </>
  )
}
